export default function GetAllXrefsForProductAndSellerService($log, $http) {
  'ngInject';

  return function (
    productId,
    responseId,
    pageSize,
    pageIndex,
    search,
    purchasePlanId
  ) {
    console.warn(
      'The getAllXrefsForProductAndSellerService has been deprecated and will be removed from a future release.'
    );

    return $http.get(
      '/aptitude/buyer/PurchasePlanServiceController/getAllXrefsForProductAndSeller',
      {
        params: {
          productId: productId,
          responseId: responseId,
          pageSize: pageSize,
          pageIndex: pageIndex,
          search: search,
          purchasePlanId: purchasePlanId
        }
      }
    );
  };
}
